import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import actions from './actions'

Vue.use(Vuex)

const state = {
  name: '',
  name_en: '',
  role: 0,
  userInfo: {
    id: '',
    name: '',
    role: '',
    first_name: '',
    last_name: '',
  },
  allRoutes: [],
  accessRoutes: [
    { name: 'user' }
  ],
  // 角色
  roleList: [
    { id: 2, name: '顾问', theme: 'warning', },
    { id: 4, name: '学生', theme: 'primary', },
    { id: 8, name: '老师/管理者', theme: 'success', },
  ],
  // 考试类型
  examTypeList: [
    { id: 1, name: 'Regular Contest', },
    { id: 2, name: 'ALL-STAR', },
  ],
  // 成绩状态
  examGradeStatusList: [
    { id: 7, name: '等待学生作答', en_s: 'Not Start', en: 'Your Contest is Waiting For You', },
    { id: 5, name: '答案已上传', en_s: 'Responses Uploaded', en: 'Your Responses Has Been Uploaded', },
    { id: 1, name: '待放分', en_s: 'Waiting', en: 'Your Score is Coming', },
    { id: 2, name: '审查中', en_s: 'Pending', en: 'Your Score is Pending/On Hold', },
    { id: 6, name: '编程题未完成', en_s: 'Programming Problem Unfinished', en: 'Your Programming Problem is Unfinished', },
    { id: 3, name: '已放分', en_s: 'Ready', en: 'Your Score is Ready', },
    { id: 4, name: '已取消', en_s: 'Cancelled', en: 'Your Score has been Cancelled', },
  ],
  // 终测结果状态
  finalExamGradeStatusList: [
    { id: 1, name: 'Unsubmit' },
    { id: 2, name: 'Pending' },
    { id: 4, name: 'In review' },
    { id: 8, name: 'Review completed', },
  ],
  finalExamGradeResStatusList: [
    { id: 1, name: 'Init' },
    { id: 2, name: 'Accept' },
    { id: 4, name: 'Waitlist' },
    { id: 8, name: 'Deny', },
  ],
  // 终测付款状态
  finalExamGradePayStatusList: [
    { id: 1, name: 'Waiting' },
    { id: 2, name: 'Success' },
    { id: 4, name: 'Fail' },
  ],
  // 终测注册状态
  finalExamGradeRegStatusList: [
    { id: 1, name: 'Waiting' },
    { id: 2, name: 'Success' },
    { id: 4, name: 'Fail' },
  ],
  // 终测晋级状态
  finalExamGradeQuaStatusList: [
    { id: 1, name: 'Waiting' },
    { id: 2, name: 'Success' },
    { id: 4, name: 'Fail' },
  ],
  // 终测类型
  finalExamGradeTypeList: [
    { id: 1, name: 'Classroom' },
    { id: 2, name: 'Junior' },
    { id: 3, name: 'Intermediate' },
    { id: 4, name: 'Senior' },
  ],

  // 当前视口宽度
  ViewportWidth: window.innerWidth,
}

const mutations = {
  SET_USER_INFO: (state, info) => {
    state.userInfo = info
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_NAME_EN: (state, name) => {
    state.name_en = name
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  CACHE_ROUTES: (state, routes) => {
    state.accessRoutes = routes
  },
  CACHE_ALL_ROUTES: (state, routes) => {
    state.allRoutes = routes
  },
  CACHE_PAGES: (state, pages) => {
    state.pages = pages
  },
}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})

export default store
